import { DispositifMin } from "@shared/models/dispositif/dispositif-min";

export class CreerDossier {
  constructor(public dispositif: DispositifMin, public siretInitiateur: string | undefined) { }
}